import React from 'react';
import { connect } from 'redux-bundler-react';
import { SidebarButton } from '../../application-controls/index';
import classnames from 'classnames';

class ThreeDButton extends React.Component {
  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(){
    const { doSwitchDimensions, threeD } = this.props;
    doSwitchDimensions(!threeD);
  }

  render() {
    const { threeD } = this.props;

    const btnClass = classnames({
      'ms': true,
      'ms-map-o': threeD,
      'ms-globe': !threeD
    })

    const title = threeD ? 'Switch to 2D Map' : 'Switch to 3D Globe';

    return (
      <SidebarButton
        iconClass={ btnClass }
        label={ title }
        title={ title }
        onClick={ this.handleClick }
      />
    );
  }
}

export default connect(
  'doSwitchDimensions',
  'selectThreeD',
  'selectCesium',
  ThreeDButton
);